import featureImage1 from './../../resources/images/all-in-one.png';
import featureImage2 from './../../resources/images/fresh-n-reliable.png';
import featureImage3 from './../../resources/images/hoory.png';

import './index.scss';

function FeaturesList() {
    return(
        <div className="features-list-wrapper">
            <ul className="features-list">
                <li className="features-list-el">
                    <div className="container">
                        <div className="features-el-info">
                            <h3 className="features-el-title">All-In-One App</h3>
                            <p className="features-el-description">Stay in the know about global events’ updates, exclusive content, interviews from our industry leader. From market trends to critical insights, challenges of the industry, and international regulations, explore your field of interest, right at your fingertips.</p>
                        </div>
                        <div className="features-el-illustration">
                            <img src={featureImage1} alt="" />
                        </div>
                    </div>
                </li>
                <li className="features-list-el">
                    <div className="container">
                        <div className="features-el-info">
                            <h3 className="features-el-title">Fresh and Reliable</h3>
                            <p className="features-el-description">At SpringNews, we have a team of highly regarded journalists who help to inform as well as entertain our international readership. With an elegant and intuitive user interface, you can use the app anywhere and anytime.</p>
                        </div>
                        <div className="features-el-illustration">
                            <img src={featureImage2} alt="" />
                        </div>
                    </div>
                </li>
                <li className="features-list-el">
                    <div className="container">
                        <div className="features-el-info">
                            <h3 className="features-el-title">Our Hoory is there for any question</h3>
                            <p className="features-el-description">AI-powered assistant that will help you navigate in the app and will answer all your questions regarding iGaming market</p>
                        </div>
                        <div className="features-el-illustration">
                            <img src={featureImage3} alt="" />
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default FeaturesList;